/**
 * Readable messages from rejected API calls (AB#6872).
 *
 * PURE module: no React, MUI, axios or auth imports.
 */

/**
 * A readable message from a rejected API call (the axios wrapper rejects with the
 * response, a list of validation messages, or an Error). Never includes the response
 * body beyond its `message`, so no row data can leak into the UI or logs.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (Array.isArray(error) && typeof error[0] === "string") return error[0];
  if (error && typeof error === "object") {
    const data = (error as { data?: unknown }).data;
    if (data && typeof data === "object") {
      const message = (data as { message?: unknown }).message;
      if (typeof message === "string" && message.trim()) return message;
    }
  }
  return fallback;
}
